import React, { useState } from 'react';
import GroupBatchList from './GroupBatchList';
import GroupBatchCreator from './BatchGroupViewer';

const BatchGroup = () => {
  const [showCreate, setShowCreate] = useState(false);

  return (
    <div className="mx-auto p-6 bg-white">
      <div className="flex items-center justify-between mb-6">
        <div className="dashboard-container-new !mb-0">
          <p className="text-slate-800 font-extrabold text-lg">Group Batch Manager</p>
        </div>
        <button
          className="px-4 py-2.5 rounded-xl font-bold text-xs uppercase tracking-wider bg-slate-800 text-white shadow-sm hover:bg-slate-900 transition-colors cursor-pointer"
          onClick={() => setShowCreate(!showCreate)}
        >
          {showCreate ? '← Back to List' : '+ Create Batch'}
        </button>
      </div>

      <div>
        {showCreate
          ? <GroupBatchCreator onClose={() => setShowCreate(false)} />
          : <GroupBatchList />
        }
      </div>
    </div>
  );
};

export default BatchGroup;
